let scopeOfPracticeInfo = {
    items: []
};

export default scopeOfPracticeInfo;